import { useEffect } from "react";
import { activeModule } from "../providers/active-module";

const useAppTitle = () => {
  useEffect(() => {
    const modulesMapName = {
      "4TIME": "Fortime",
      IRSKOM: "Irskom",
      CORE: "Parhato",
      PARHATO2: "Parhato 2",
    } as const;

    const title = modulesMapName[activeModule as keyof typeof modulesMapName];
    document.title = title;
  }, []);
};

export default useAppTitle;
